const STEPS = [
  {
    title: "Kontakt & kostnadsfritt hembesök",
    text: "Ring eller skriv. Lars kommer ut, tittar på förutsättningarna och lämnar en offert. Det kostar ingenting.",
  },
  {
    title: "Genomgång & tydlig överenskommelse",
    text: "Innan start går vi noggrant igenom projektet tillsammans, så att vi är överens om vad som ska göras.",
  },
  {
    title: "Genomförande",
    text: "Vi bygger och samordnar andra hantverkare när det behövs. Målet är att bli klara inom den tid vi kommit överens om.",
  },
];

export const Process = () => (
  <section aria-labelledby="process-title" className="py-20 md:py-28 lg:py-36" data-testid="process-section">
    <div className="container-site">
      <div className="reveal max-w-2xl">
        <p className="eyebrow">Så går det till</p>
        <h2 id="process-title" className="h2 mt-5">Tre steg från första samtal till färdigt jobb</h2>
      </div>
      <ol className="mt-14 grid border-t border-line md:mt-20 md:grid-cols-3">
        {STEPS.map((s, i) => (
          <li
            key={s.title}
            className="reveal border-b border-line py-10 md:border-b-0 md:py-12 md:pr-10 md:[&:not(:first-child)]:border-l md:[&:not(:first-child)]:pl-10"
            style={{ transitionDelay: `${i * 120}ms` }}
            data-testid={`process-step-${i + 1}`}
          >
            <span className="font-display text-5xl italic text-moss lg:text-6xl" aria-hidden="true">0{i + 1}</span>
            <h3 className="mt-6 font-display text-2xl leading-snug text-ink">{s.title}</h3>
            <p className="mt-4 text-base leading-relaxed text-ink2">{s.text}</p>
          </li>
        ))}
      </ol>
    </div>
  </section>
);
